// Карточки шаблонов в виде листа документа. На главной карточка запускает мастер прямо в чате.
import type { MouseEvent } from "react";
import { boot } from "../boot";
import { plural } from "../lib/text";
import { DocPage } from "./DocPage";

type Props = { limit?: number; soonLimit?: number; onStart?: (code: string, label: string, event: MouseEvent) => void };

export function Sheets({ limit, soonLimit, onStart }: Props) {
  return (
    <>
      {boot.templates.slice(0, limit).map((t) => (
        <a key={t.slug} className="sheet-card" href={`/?start=doc:${t.slug}`}
          onClick={onStart ? (event) => onStart(`doc:${t.slug}`, t.title, event) : undefined}>
          <span className="sheet sheet-real">
            <span className="sheet-heading">
              <span className="sheet-title">{t.short_title || t.title}</span>
              <span className="sheet-meta">{t.law} · {plural(t.question_count, "вопрос", "вопроса", "вопросов")}</span>
            </span>
            <span className="sheet-paper" aria-hidden="true"><span className="doc-thumb"><DocPage paragraphs={boot.previews[t.slug]} /></span></span>
          </span>
        </a>
      ))}
      {boot.soonDocuments.slice(0, soonLimit).map(([heading, title]) => (
        <div key={title} className="sheet-card soon">
          <span className="sheet">
            <span className="sheet-heading">
              <span className="sheet-title">{title}</span>
              <span className="sheet-meta"><em className="badge">скоро</em> образец готовит адвокат</span>
            </span>
            <span className="sheet-paper sheet-placeholder" aria-hidden="true"><span className="sheet-word">{heading}</span></span>
          </span>
        </div>
      ))}
    </>
  );
}
